import { AxiosInstance, AxiosResponse } from 'axios';
import { VatValidation } from '../../models/vat.model';
import ColisportApiResource from './colisport-api-resource.model';

export default class VatApi implements ColisportApiResource {
  readonly apiUrlPath = 'vat';

  constructor(readonly httpClient: AxiosInstance) {}

  async getVadidation(
    countryCode: string,
    vatNumber: string,
  ): Promise<AxiosResponse<VatValidation>> {
    return this.httpClient.get(
      `${this.apiUrlPath}/validate?countryCode=${countryCode}&vatNumber=${vatNumber}`,
    );
  }
}
